module.exports = __webpack_public_path__ + "img/daily-vlog.f8a13a1a.webp";